<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || "input-service" | translate }}</mat-label
      ><input
        type="text"
        matInput
        [matAutocomplete]="autoComplete"
        formControlName="name"
      />
      <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let service of services"
          (onSelectionChange)="handleServiceChange($event, service)"
          [value]="service.name"
          class="autocomplete"
        >
          {{ service.name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        translate
        *ngIf="this.searchForm.controls.name.touched && !this.searchForm.valid"
        >{{ "required-service" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
